<template>
    <div class="search-result__set">
        <h2 class="results__heading">{{ resultSet.sectionHeadline }}&nbsp;<span class="resultCount">({{ resultSet.resultCount }})</span></h2>
        <template v-if="resultSet.type === resultTypes.text">
            <template v-for="(result, index) in resultSet.results">
                <template v-if="resultSetSetting === resultKinds.all">
                    <template v-if="index < 4">
                        <search-result-text :result="result" :key="result.id"></search-result-text>
                    </template>
                </template>
                <template v-else>
                    <search-result-text :result="result" :key="result.id"></search-result-text>
                </template>
            </template>
        </template>
        <template v-if="resultSet.type === resultTypes.tile">
            <div class="row">
                <template v-for="(result, index) in resultSet.results">
                    <template v-if="resultSetSetting === resultKinds.all">
                        <template v-if="index < 3">
                            <search-result-tile class="col-6 col-md-4 col-lg-3" :result="result" :key="result.id"></search-result-tile>
                        </template>
                        <template v-if="index === 3">
                            <search-result-tile class="col-6 col-md-4 col-lg-3 hide-tablet" :result="result" :key="result.id"></search-result-tile>
                        </template>
                    </template>
                    <template v-else>
                        <search-result-tile class="col-6 col-md-4 col-lg-3" :result="result" :key="result.id" @image-loaded="onImageLoaded"></search-result-tile>
                    </template>
                </template>
            </div>
        </template>
        <template v-if="resultSet.type === resultTypes.downloads">
            <search-result-downloads :downloads="resultSet.results" />
        </template>
        <template v-if="resultSet.resultCount > resultSet.results.length">
            <div class="button-wrapper v-center right">
                <button @click="loadMore" class="button button--secondary" :class="{'button--loading': isLoadingMore}">{{ localization.buttons.more }}</button>
            </div>
        </template>
    </div>
</template>

<script>
    import constants from "../../shared/constants";
    import SearchResultText from "../search-result-text/search-result-text.vue";
    import SearchResultTile from "../search-result-tile/search-result-tile.vue";
    import SearchResultDownloads from '@search/components/search-result-downloads/search-result-downloads';

    export default {
        name: "search-result-set",
        components: {SearchResultDownloads, SearchResultTile, SearchResultText},
		data() {
			return {
				imagesLoaded: 0
			}
		},
        computed: {
            resultTypes() {
                return constants.resultType;
            },
            resultKinds() {
                return constants.resultKind;
            },
            localization () {
                return this.$store.getters.localize;
            },
            resultSetSetting () {
                return this.$store.state.category;
            },
			isLoadingMore() {
            	return this.$store.state.isLoadingMore;
			}
        },
        props: {
            resultSet: {
                type: Object,
                default: function () {
                    return {
                        sectionHeadline: "Result Heading",
                        type: constants.resultType.text,
                        results: [
                            {
                                link: "#",
                                title: "▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅",
                                abstract: "▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅ ▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅"
                            },
                            {
                                link: "#",
                                title: "▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅",
                                abstract: "▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅ ▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅"
                            },
                            {
                                link: "#",
                                title: "▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅",
                                abstract: "▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅ ▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅"
                            },
                        ],
                        resultCount: 0
                    }
                }
            }
        },
		watch: {
        	resultSet: function(val) {
        		this.imagesLoaded = 0;
			}
		},
        methods: {
            loadMore() {
            	if (!this.isLoadingMore) {
					this.$store.dispatch('changeCategory', this.resultSet.kind);
					this.$store.dispatch('loadmore')
				}
            },
			onImageLoaded() {
				// bwoah... Das funktioniert nur für den Fall für den es ursprünglich implementiert wurde
				// sprich das triggern des scrollens, wenn alle Bilder geladen wurden.
				// Bei Filter-Änderungen werden nur die Bilder neu generiert, die sich ändern.
				// Wenn man also bei einer Filter-Änderung von den 12 Ergebnissen nur 5 neue Ergebnisse hat, dann zählt das nur bis 5.
				this.imagesLoaded++;
				// console.log('An image was loaded', this.imagesLoaded, 'of', this.resultSet.results.length);

				if (this.imagesLoaded === this.resultSet.results.length) {
					this.$store.dispatch('allResultImagesLoaded');
				}
			}
        },
		updated: function () {
			this.$nextTick(function () {
				if (this.resultSet.type === this.resultTypes.text) {
					this.$store.dispatch('allResultImagesLoaded'); // Weil ... gibt ja keine Bilder!!11
				}
			})
		}
    }
</script>
